module.exports = __webpack_public_path__ + "img/planting_04.65538ee.webp";